import { initializeApp, type FirebaseApp } from "firebase/app";
import {
  connectAuthEmulator, getAuth, onAuthStateChanged, signInWithCustomToken,
  signOut, type Auth, type User,
} from "firebase/auth";
import { config } from "../config";

let app: FirebaseApp | undefined;
let auth: Auth | undefined;

export function getFirebaseAuth(): Auth {
  if (!auth) {
    app = initializeApp({ apiKey: config.firebase.apiKey, projectId: config.firebase.projectId });
    auth = getAuth(app);
    if (config.firebase.authEmulatorUrl) {
      connectAuthEmulator(auth, config.firebase.authEmulatorUrl, { disableWarnings: true });
    }
  }
  return auth;
}

export function subscribeAuth(cb: (user: User | null) => void): () => void {
  return onAuthStateChanged(getFirebaseAuth(), cb);
}

export const firebaseSignInWithCustomToken = (token: string) =>
  signInWithCustomToken(getFirebaseAuth(), token);

export const firebaseSignOut = () => signOut(getFirebaseAuth());
